import { useTranslation } from 'react-i18next';

export default function WhyChoose() {
  const { t } = useTranslation();

  const features = [
    {
      icon: 'ri-team-line',
      title: t('whyFeature1Title'),
      description: t('whyFeature1Description')
    },
    {
      icon: 'ri-time-line',
      title: t('whyFeature2Title'),
      description: t('whyFeature2Description')
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('whyFeature3Title'),
      description: t('whyFeature3Description')
    },
    {
      icon: 'ri-shield-check-line',
      title: t('whyFeature4Title'),
      description: t('whyFeature4Description')
    }
  ];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            <strong>{t('whyChooseTitle')}</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('whyChooseDescription')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-gray-100 cursor-pointer group text-center"
            >
              <div className="w-16 h-16 bg-[rgb(0,0,139)] rounded-full flex items-center justify-center mb-6 mx-auto group-hover:scale-110 transition-transform">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}